export default "__VITE_ASSET__DPkQ3MEb__"